import topoToGeo from "./topoToGeo";
import getCentroids from "./dataHelpers/getCentroids";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([import("~/data/pa-evictions.json")]).then(
    ([topoJson]) => {
      const data = {};
      data.geoData = topoToGeo(topoJson, "pa-evictions");
      data.iconData = getCentroids(data.geoData, "efr");
      return data;
    }
  );
};

export default loadData;
